import React from "react";
import { lazyWithSync } from "./lazyWithSync";
import Rolemanagement from "../pages/role-management/role-management";
import RolemanagementList from "../pages/role-management/role-managementListing";
// import CodeListing from "../pages/code-management";

const Dashboard = lazyWithSync(() => import("../pages/dashboard"));
const NotFound = lazyWithSync(() => import("../pages/notFound"));
const Login = lazyWithSync(() => import("../pages/auth/login"));
const ForgotPassword = lazyWithSync(() =>
  import("../pages/auth/forgot-password")
);
const ResetPassword = lazyWithSync(() =>
  import("../pages/auth/reset-password")
);
const Profile = lazyWithSync(() => import("../pages/profile/index"));
const CMSSetting = lazyWithSync(() => import("../pages/cms/cms-setting"));
const EditCMSSetting = lazyWithSync(() =>
  import("../pages/cms/edit-cms-setting")
);
const Settings = lazyWithSync(() => import("../pages/settings"));
const CategoryManagement = lazyWithSync(() =>
  import("../pages/category-management/index")
);
const AddEditCategory = lazyWithSync(() =>
  import("../pages/category-management/add-edit-category")
);
const ViewCategory = lazyWithSync(() =>
  import("../pages/category-management/view-category")
);
const CurriculumManagement = lazyWithSync(() =>
  import("../pages/curriculum-management/index")
);
const ProductManagement = lazyWithSync(() =>
  import("../pages/product-management/index")
);
const AddEditProduct = lazyWithSync(() =>
  import("../pages/product-management/add-edit-product")
);
const AddRenewAbleProduct = lazyWithSync(() =>
  import("../pages/product-management/AddRenewAbleProduct")
);

const AddNewSubLession = lazyWithSync(() =>
  import("../pages/product-management/AddNewSubLession")
);
const MainModuleManagement = lazyWithSync(() =>
  import("../pages/main-module-management/index")
);
const AddEditModule = lazyWithSync(() =>
  import("../pages/main-module-management/add-edit-module")
);
const SchoolManagement = lazyWithSync(() =>
  import("../pages/school-management/index")
);
const AddSchool = lazyWithSync(() =>
  import("../pages/school-management/add-school")
);
const ViewSchool = lazyWithSync(() =>
  import("../pages/school-management/view-school")
);
const ViewStudent = lazyWithSync(() =>
  import("../pages/school-management/student-management/view-student")
);
const ViewProduct = lazyWithSync(() =>
  import("../pages/product-management/ViewProduct")
);
const CodeListing = lazyWithSync(() =>import('../pages/code-management'))

const HeadingListing = lazyWithSync(() =>
  import("../pages/Heading/index")
);

const GlbFileUpload = lazyWithSync(() =>
  import("../pages/Glb-file-upload/index")
);

const GlbUpload = lazyWithSync(() =>
  import("../pages/Glb-file-upload/glb-upload")
);

const JsonUpload = lazyWithSync(() =>
  import("../pages/Glb-file-upload/json-upload")
);

const AddEditHeading = lazyWithSync(() =>
  import("../pages/Heading/add-edit-heading")
);

export const RoutesList = [
  {
    layout: <Login />,
    path: "/login",
    name: "Login",
    isAuthProtected: false,
  },
  {
    layout: <ForgotPassword />,
    path: "/forgot-password",
    name: "Forgot-Password",
    isAuthProtected: false,
  },
  {
    layout: <ResetPassword />,
    path: "/reset-password/:id",
    name: "Reset-Password",
    isAuthProtected: false,
  },
  {
    layout: <Profile />,
    path: "/profile",
    name: "Profile",
    isAuthProtected: true,
  },
  {
    layout: <Dashboard />,
    path: "/dashboard",
    name: "Dashboard",
    isAuthProtected: true,
  },
  {
    layout: <CMSSetting />,
    path: "/cms-settings",
    name: "CMS Settings",
    isAuthProtected: true,
  },
  {
    layout: <EditCMSSetting />,
    path: "/cms-settings/edit-cms-setting/:id",
    name: "Edit CMS Settings",
    isAuthProtected: true,
  },
  {
    layout: <Settings />,
    path: "/settings",
    name: "Settings",
    isAuthProtected: true,
  },
  {
    layout: <CategoryManagement />,
    path: "/category-management",
    name: "Category Management",
    isAuthProtected: true,
  },
  {
    layout: <AddEditCategory />,
    path: "/category-management/add-category",
    name: "Add Category",
    isAuthProtected: true,
  },
  {
    layout: <AddEditCategory />,
    path: "/category-management/edit-category/:id",
    name: "Edit Category",
    isAuthProtected: true,
  },
  {
    layout: <ViewCategory />,
    path: "/category-management/view-category/:id",
    name: "View Category",
    isAuthProtected: true,
  },
  {
    layout: <CurriculumManagement />,
    path: "/curriculum-management",
    name: "Curriculum Management",
    isAuthProtected: true,
  },
  {
    layout: <ProductManagement />,
    path: "/product-management",
    name: "Product Management",
    isAuthProtected: true,
  },
  {
    layout: <AddEditProduct />,
    path: "/product-management/add-product",
    name: "Add Product",
    isAuthProtected: true,
  },
  {
    layout: <AddEditProduct />,
    path: "/product-management/edit-product/:id",
    name: "Edit Product",
    isAuthProtected: true,
  },
  {
    layout: <MainModuleManagement />,
    path: "/main-module-management",
    name: "Main Module Management",
    isAuthProtected: true,
  },
  {
    layout: <AddEditModule />,
    path: "/main-module-management/add-module",
    name: "Add Module",
    isAuthProtected: true,
  },
  {
    layout: <AddEditModule />,
    path: "/main-module-management/edit-module/:id",
    name: "Edit Module",
    isAuthProtected: true,
  },
  {
    layout: <RolemanagementList/>,
    path: "/role-management",
    name: "Role Management",
    isAuthProtected: true,
  },
  {
    layout: <Rolemanagement />,
    path: "/role-management/add/:id",
    name: "Role Management List",
    isAuthProtected: true,
  },
  {
    layout: <Rolemanagement />,
    path: "/role-management/edit/:id",
    name: "Role Management List",
    isAuthProtected: true,
  },
  {
    layout: <Rolemanagement />,
    path: "/role-management/view/:id",
    name: "Role Management List",
    isAuthProtected: true,
  },
  {
    layout: <SchoolManagement />,
    path: "/school-management",
    name: "School Management",
    isAuthProtected: true,
  },
  {
    layout: <AddSchool />,
    path: "/school-management/add-school",
    name: "Add School",
    isAuthProtected: true,
  },
  {
    layout: <AddSchool />,
    path: "/school-management/edit-school/:id",
    name: "Add School",
    isAuthProtected: true,
  },
  {
    layout: <ViewSchool />,
    path: "/school-management/view-school/:id",
    name: "View School",
    isAuthProtected: true,
  },
  {
    layout: <ViewStudent />,
    path: "/school-management/view-student/:id",
    name: "View Student",
    isAuthProtected: true,
  },

  {
    layout: <AddRenewAbleProduct />,
    path: "/add/new/renewableproduct/:productid",
    name: "Add RenewAble Product",
    isAuthProtected: true,
  },

  {
    layout: <AddNewSubLession />,
    path: "/renewable-product-management/add/sublession/:name/:lessionid",
    name: "Add New Sub Lession ",
    isAuthProtected: true,
  },

  {
    layout: <ViewProduct />,
    path: "/product/view-product/:productid",
    name: "View Product",
    isAuthProtected: true,
  },
  {
    layout: <CodeListing />,
    path: "/code-management",
    name: "Code ManageMent ",
    isAuthProtected: true,
  },
  {
    layout: <HeadingListing />,
    path: "/heading-management",
    name: "Heading Management",
    isAuthProtected: true,
  },
  {
    layout: <AddEditHeading />,
    path: "/heading/view-heading/:id",
    name: "Add Heading",
    isAuthProtected: true,
  },
  {
  layout: <AddEditHeading />,
  path: "/heading-management/add-school",
  name: "Add Heading",
  isAuthProtected: true,
  },

  {
    layout: <AddEditHeading/>,
    path: "/heading-management/add-heading",
    name: "Add Heading",
    isAuthProtected: true,
  },
  {
    layout: <AddEditHeading />,
    path: "/heading/view-heading/:id",
    name: "Add Heading",
    isAuthProtected: true,
  },
  {
    layout: <GlbFileUpload />,
    path: "/glb-file",
    name: "Glb File Upload",
    isAuthProtected: true,
  },
  {
    layout: <GlbUpload />,
    path: "/glb-file/glb-upload",
    name: "Glb File Upload",
    isAuthProtected: true,
  },
  {
    layout: <JsonUpload />,
    path: "/json-file/json-upload",
    name: "Json File Upload",
    isAuthProtected: true,
  },
  {
    layout: <NotFound />,
    path: "*",
    name: "404",
    isAuthProtected: false,
  },
];
